import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';

const PublicComments = ({ noCommentsText }) => {
  const {
    BidStore: { auctionProduct },
  } = useStores();
  return (
    <>
      {auctionProduct && auctionProduct.publicComments
        ? auctionProduct.publicComments
        : noCommentsText}
    </>
  );
};

PublicComments.propTypes = {
  noCommentsText: PropTypes.string,
};

PublicComments.defaultProps = {
  noCommentsText: 'No comments',
};

export default observer(PublicComments);
